import { AnimatePresence, motion } from "framer-motion";
import Box from "@mui/joy/Box";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import IconButton from "@mui/joy/IconButton";
import { Modal, ModalDialog, ModalOverflow } from "@mui/joy";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CheckBoxRoundedIcon from "@mui/icons-material/CheckBoxRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import AspectRatioRoundedIcon from "@mui/icons-material/AspectRatioRounded";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";

const HINTS = [
  {
    icon: <CheckBoxRoundedIcon sx={{ fontSize: 20 }} />,
    title: "Выбрать",
    text: "Выбрать книгу для заказа. Выбранные книги попадут в «Оформить заказ».",
  },
  {
    icon: <EditRoundedIcon sx={{ fontSize: 20 }} />,
    title: "Переименовать",
    text: "Изменить название книги.",
  },
  {
    icon: <AspectRatioRoundedIcon sx={{ fontSize: 20 }} />,
    title: "Размер",
    text: "Изменить формат и размер книги (мм) и число страниц.",
  },
  {
    icon: <ContentCopyRoundedIcon sx={{ fontSize: 20 }} />,
    title: "Копия",
    text: "Создать копию книги, если вы хотите заказать несколько одинаковых книг.",
  },
  {
    icon: <OpenInNewRoundedIcon sx={{ fontSize: 20 }} />,
    title: "Открыть",
    text: "Загрузить книгу в редактор и продолжить оформление.",
  },
  {
    icon: <DeleteOutlineRoundedIcon sx={{ fontSize: 20 }} />,
    title: "Удалить",
    text: "Удалить книгу навсегда. Действие необратимо.",
  },
];

export default function BookActionsInfoModal({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <Modal open={open} onClose={onClose} sx={{ zIndex: 10020 }}>
            <ModalOverflow sx={{ height: "auto", p: 0 }}>
                <ModalDialog
                    size="md"
                    component={motion.div}
                    initial={{ opacity: 0, y: -8, scale: 0.98 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 8, scale: 0.98 }}
                    transition={{ duration: 0.18, ease: "easeInOut" }}
                    sx={{
                    width: "min(440px, 92vw)",
                    borderRadius: "18px",
                    p: 0,
                    overflow: "hidden",
                    }}
                >
                    {/* Шапка */}
                    <Box sx={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    px: 2.5, py: 2, borderBottom: "1px solid", borderColor: "divider",
                    }}>
                    <Typography level="title-md" sx={{ fontWeight: 800 }}>
                        Что делают кнопки
                    </Typography>
                    <IconButton size="sm" variant="plain" color="neutral" onClick={onClose}
                        sx={{ borderRadius: "10px" }}>
                        <CloseRoundedIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                    </Box>

                    {/* Список подсказок */}
                    <Box sx={{ px: 2.5, py: 2, maxHeight: "70vh", overflowY: "auto" }}>
                    <Stack gap={1.5}>
                        {HINTS.map((h, i) => (
                        <Stack key={i} direction="row" gap={1.5} alignItems="flex-start">
                            <Box sx={{
                            flexShrink: 0, width: 36, height: 36, borderRadius: "10px",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            bgcolor: "color-mix(in srgb, var(--joy-palette-primary-500) 8%, transparent)",
                            color: "primary.500",
                            }}>
                            {h.icon}
                            </Box>
                            <Box sx={{ minWidth: 0 }}>
                            <Typography level="body-sm" sx={{ fontWeight: 700 }}>
                                {h.title}
                            </Typography>
                            <Typography level="body-xs" sx={{ color: "text.tertiary", lineHeight: 1.4 }}>
                                {h.text}
                            </Typography>
                            </Box>
                        </Stack>
                        ))}
                    </Stack>
                    </Box>
                </ModalDialog>
            </ModalOverflow>
        </Modal>
      )}
    </AnimatePresence>
  );
}